import { ref } from "vue";
import { defineStore } from "pinia";
import { IKeyValue } from "./store";
import { commClient } from "fw4-library";

interface IGeneralStore {
    countryList : IKeyValue[] | undefined;
    countryPhoneList: IKeyValue[] | undefined;
    postalCodeList: IKeyValue[] | undefined;
}

export const useGeneralStore = defineStore("generalStore", () => {
    const state = ref<IGeneralStore>({
        countryList: undefined,
        countryPhoneList: undefined,
        postalCodeList: undefined,
    });

    async function loadCountryLoad() {
        if (state.value.countryList == undefined) {
            await commClient.executeMethodAsync("sf.CountryList",{}
            ).then(async (Message: any) => {
                if (Message) {  
                    state.value.countryList = Message as IKeyValue[];
                }
            });
        }
        return state.value.countryList;
    }

    async function postalCodeLoad() {
        if (state.value.postalCodeList == undefined) {
            await commClient.executeMethodAsync("sf.PostalCode",{}
            ).then(async (Message: any) => {
                if (Message) {  
                    state.value.postalCodeList = Message as IKeyValue[];
                }
            });
        }

        return state.value.postalCodeList;
    }

    async function countryPhoneLoad() {
        if (state.value.countryPhoneList == undefined) {
            await commClient.executeMethodAsync("sf.CountryPhoneList",{}
            ).then(async (Message: any) => {
                if (Message) {  
                    state.value.countryPhoneList = Message as IKeyValue[];
                }
            });
        }
        return state.value.countryPhoneList;
    }

    return { 
        state,
        loadCountryLoad,
        postalCodeLoad,
        countryPhoneLoad
    };
});